/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment } from 'react';
import { INPermission } from 'src/services/IAM/AdminPermissions/AdminPermissions.interface';
import CollapsibleTable from 'src/views/AdminUser/components/CollapsibleTable';

/**
 * @module TablePermissions
 * 
 * Componente para mostrar una tabla de permisos administrados.
 * Este componente utiliza un componente `CollapsibleTable` para renderizar
 * los permisos en una interfaz colapsable.
 * 
 * @param {Object} props - Props del componente.
 * @param {INPermission[]} props.permissions - Lista de permisos a mostrar.
 * @param {Function} props.loadPermissions - Función para cargar permisos.
 * @param {Function} props.handlerSelectedPermissions - Manejador para permisos seleccionados.
 * 
 * @example
 * <TablePermissions
 *   permissions={myPermissions}
 *   loadPermissions={myLoadPermissions}
 *   handlerSelectedPermissions={myHandlerSelectedPermissions}
 * />
 * 
 * @returns {JSX.Element} El componente TablePermissions.
 */
const TablePermissions = ({
  permissions,
  loadPermissions,
  handlerSelectedPermissions,
}: {
  permissions: INPermission[];
  loadPermissions: (params: { currentPage: number; pageSize: number }) => void;
  handlerSelectedPermissions: (permissions: INPermission) => void;
}) => {
  return (
    <Fragment>
      <CollapsibleTable
        withActions={true}
        loadPermissions={loadPermissions}
        permissionsProp={permissions}
        handlerSelectedPermissions={handlerSelectedPermissions}
      />
    </Fragment>
  );
};

export default TablePermissions;
